import { StandardEntity } from '@infodata-group/inf-commons';
import { VehicleExpenseDto } from '../interface/vehicle-expense.dto';

export class VehicleExpense extends StandardEntity {
  public date: string;
  public amount: number;
  public type: string;
  public description: [string];
  public ged: string;
  public vehicleId: string;

  constructor() {
    super();
  }

  public override serialize(): VehicleExpenseDto {
    return {
      id: this.id,
      label: this.label,
      date: this.date,
      amount: this.amount,
      type: this.type,
      description: this.description,
      ged: this.ged,
      vehicleId: this.vehicleId,
    };
  }
}
